webpackJsonp([125706681701135],{

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookWebsocketsActionCable = __webpack_require__(108);
	
	var _LoreHookWebsocketsActionCable2 = _interopRequireDefault(_LoreHookWebsocketsActionCable);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookWebsocketsActionCable2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'lore-hook-websockets-actioncable'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Source code for this hook can be found on GitHub ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/tree/master/packages/lore-hook-websockets-actioncable' },
	        'at this link'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Purpose'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This hook is built on top of the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/tree/master/packages/lore-websockets' },
	        'lore-websockets'
	      ),
	      ' library and implements the interface for ActionCable.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Example'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'See the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/tree/master/examples/websockets' },
	        'websockets example'
	      ),
	      ' to see this hook in action.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Example Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ActionCable hook behaves identical to the SocketIO hook, except for the implementation. The big callout here is the interface that ActionCable uses, which is a bit different than the other two implementations.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Instead of using ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'namespaces'
	      ),
	      ', ActionCable uses ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'channels'
	      ),
	      '. I ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'think'
	      ),
	      ' they\'re equivalent, but not sure. Meaning Socket.io breaks data up into namespaces & rooms, but ActionCable seems to only use one of those (?). I played with it only enough to get this to work and see if the interface could adapt to something not based in Node : )'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import _ from \'lodash\';\n      import { WebSocketConnection } from \'lore-websockets\';\n      import ActionCable from \'actioncable\';\n\n      export default WebSocketConnection.extend({\n\n        // serverUrl: \'http://localhost:1337/cable\',\n        // channel: \'PostsChannel\',\n\n        connect: function() {\n          this.cable = ActionCable.createConsumer(this.serverUrl);\n        },\n\n        subscribe: function subscribe() {\n          var that = this;\n\n          this.cable.subscriptions.create(this.channel, {\n            connected: function() {\n              console.log(\'ActionCable:WebSocket - connected!\')\n            },\n\n            disconnected: function() {\n              console.log(\'ActionCable:WebSocket - disconnected!\')\n            },\n\n            received: function(data) {\n              that.dispatch(data);\n            }\n          });\n        }\n      });\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-websockets-actioncable-index-js-94750f96ed13fc2f5343.js